var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.truncated)+" "),(!_vm.textShorterThanCharLimit)?_c('button',{staticClass:"ml-3",attrs:{"type":"button"},on:{"click":function($event){_vm.expand = !_vm.expand}}},[_vm._v(" "+_vm._s(_vm.expand ? 'See Less' : 'Read More')+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }